import React, { createContext, useContext, useState, useMemo, ReactNode } from 'react';
import { ThemeMode, ThemeColors, getThemeColors } from '../utils/themeColors';

interface ThemeContextValue {
  mode: ThemeMode;
  colors: ThemeColors;
  toggleMode: () => void;
}

const ThemeContext = createContext<ThemeContextValue>({
  mode: 'light',
  colors: getThemeColors('light'),
  toggleMode: () => undefined,
});

export const useThemeContext = () => useContext(ThemeContext);

interface Props {
  children: ReactNode;
}

const ThemeContextProvider = ({ children }: Props) => {
  const [mode, setMode] = useState<ThemeMode>('light');

  const toggleMode = () => setMode((prev) => (prev === 'light' ? 'dark' : 'light'));

  const value = useMemo<ThemeContextValue>(
    () => ({ mode, colors: getThemeColors(mode), toggleMode }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [mode]
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export default ThemeContextProvider;
